/**
 * Tope de la consulta. Sin él, un `fetch` colgado dejaba el login esperando para siempre.
 *
 * `AbortController` + `setTimeout` y no `AbortSignal.timeout`: este no existe hasta iOS 16 y la
 * app móvil sigue admitiendo iOS 15. Es el mismo patrón de `movil/versionMinima.ts`.
 */
const ESPERA_MAXIMA_MS = 10_000;

const getMaintenancePublic = async () => {
	const cancelar = new AbortController();
	const reloj = setTimeout(() => cancelar.abort(), ESPERA_MAXIMA_MS);

	try {
		const response = await fetch(`${process.env.REACT_APP_BASE_API}/options/get/maintenance`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
			signal: cancelar.signal
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return await response.json();
	} finally {
		clearTimeout(reloj);
	}
};

export default getMaintenancePublic;
